export const GET_PAGES = 'GET_PAGES'
export const GET_APP = 'GET_APP'
export const VIEW_NAV = 'VIEW_NAV'
export const VIEW_BODY = 'VIEW_BODY'
export const VIEW_TYPES = 'VIEW_TYPES'
export const VIEW_SHOWMODAL = 'VIEW_SHOWMODAL'
export const VIEW_MODALCONTENT = 'VIEW_MODALCONTENT'



// WEBPACK FOOTER //
// ./src/shared/store/mutation-types.js